<div
  class="agent-file-attachment-card"
  [class.agent-file-attachment-card--loading]="isResolvingUrl"
  [class.agent-file-attachment-card--streaming]="isStreaming"
>
  <div class="agent-file-attachment-card__icon" aria-hidden="true">
    <img class="agent-file-attachment-card__icon-image" [src]="iconSrc" alt="" />
  </div>

  <div class="agent-file-attachment-card__content">
    <div class="agent-file-attachment-card__filename" [title]="fileName">
      {{ displayFileName || fileName }}
    </div>
    <div class="agent-file-attachment-card__actions" *ngIf="showActions">
      <button
        *ngIf="canPreview"
        type="button"
        class="agent-file-attachment-card__action"
        (click)="onPreviewClick()"
        [disabled]="actionsDisabled"
        aria-label="Preview file"
      >
        <span
          class="agent-file-attachment-card__action-icon agent-file-attachment-card__action-icon--eye"
          aria-hidden="true"
        ></span>
        <span>Preview</span>
      </button>
      <span *ngIf="canPreview" class="agent-file-attachment-card__separator" aria-hidden="true">|</span>
      <button
        type="button"
        class="agent-file-attachment-card__action"
        (click)="onDownloadClick()"
        [disabled]="actionsDisabled"
        aria-label="Download file"
      >
        <span
          class="agent-file-attachment-card__action-icon agent-file-attachment-card__action-icon--download"
          aria-hidden="true"
        ></span>
        <span>Download</span>
      </button>
    </div>
  </div>
</div>
